import React from 'react';
import { toast, ToastOptions } from 'react-toastify';
import { Toast } from '@morressier/ts';

export const simpleToast = (text: string, options: ToastOptions = { autoClose: 5000 }) =>
  toast(<Toast text={text} />, options);
